<template>
    <div id="admin">
        <div v-if="!signedIn">
        <!--        <amplify-authenticator></amplify-authenticator>-->
        <!--    </div>-->
            <input type="text" name="" placeholder="Login" v-model="login"><br />
            <input type="password" name="" placeholder="Password" v-model="password"><br />
            <button @click="signIn">Sign In</button>
        </div>

        <div v-if="signedIn">
            <!--        <amplify-sign-out class="signout"></amplify-sign-out>-->

            <button @click="signOut">Sign Out</button>
        </div>
    </div>
</template>

<script>
    //https://www.youtube.com/watch?v=C7JDwNIAUMk
    //Amplify, auth and upload: https://medium.com/@dabit3/how-to-build-serverless-vue-applications-with-aws-amplify-67d16c79e9d6
    import { AmplifyEventBus } from 'aws-amplify-vue'
    import Amplify, {Auth} from 'aws-amplify'
    //import awsconfig from './aws-exports';
    //Amplify.configure(awsconfig);
    export default {
        name: 'Admin',
        data() {
            return {
                signedIn: false,
                login: '',
                password: '',
                msg: 'Admin'
            }
        },
        props: {
            //msg: String,
        },
        created(){
            this.findUser();
        },
        computed: {
            loggedIn() {
                return this.signedIn;
            }
        },
        methods: {
            signIn() {
                Auth.signIn(this.login, this.password)
                    .then(user => {
                        this.signedIn = true;
                        // this.signedIn = !!user;
                        // this.user = user;
                    })
                    .catch(err => console.log(error));
            },
            async findUser() {
                const user = await Auth.currentAuthenticatedUser();
                this.signedIn = true;
                this.user = user;
                console.log(user);
            },
            signOut() {
                Auth.signOut()
                    .then(data => {
                        this.signedIn = !!data;
                    })
                    .catch(err => console.log(error));
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }
</style>
